import React, {useEffect} from 'react';
import {usePersonalData} from 'presentation/hooks';
import {useBookingFlowStepsStore} from 'presentation/modules/booking/shared/store/useBookingFlowStepsStore';
import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useNavigate} from 'react-router-dom';
import {useBookingConfirmationDrawer} from '../../hooks/useBookingConfirmationDrawer';
import {useBookingPlanChangeStore} from '../../store/useBookingPlanChangeStore';
import {handleServiceTypeConfigs} from '../../utils/handleServiceType/handleServiceTypeConfigs';
import {SimpleConfirmationDrawer} from './SimpleConfirmationDrawer';
import {useValidateBookingServiceType} from '../../hooks/useValidateBookingServiceType';

function ConfirmationDrawer() {
	const navigate = useNavigate();
	const {currentPhone, currentEmail} = usePersonalData();
	const setBookingData = useBookingStore(state => state.setBookingData);
	const resetBookingData = useBookingStore(state => state.resetBookingData);
	const resetBookingFlowStep = useBookingFlowStepsStore(state => state.resetBookingStep);

	const {
		bookingConfirmationDrawerIsOpened,
		handleOpenBookingConfirmationDrawer,
		handleCloseBookingConfirmationDrawer,
		selectedServiceType,
	} = useBookingConfirmationDrawer();

	const isComingFromBookingFlow = useBookingPlanChangeStore(
		state => state.isComingFromBookingFlow,
	);
	const setIsComingFromBookingFlow = useBookingPlanChangeStore(
		state => state.setIsComingFromBookingFlow,
	);

	const {isServiceTypeValid} = useValidateBookingServiceType();

	const handleConfirmAndContinue = () => {
		resetBookingData();
		resetBookingFlowStep();
		const currentSearchParams = new URLSearchParams(window.location.search);
		const route = handleServiceTypeConfigs({
			currentSearchParams,
			setBookingData,
			selectedServiceType,
			phone: currentPhone,
			email: currentEmail,
		});
		navigate(route);
	};

	useEffect(() => {
		if (!isComingFromBookingFlow) return;

		if (isServiceTypeValid(selectedServiceType)) {
			handleOpenBookingConfirmationDrawer();
		}

		setIsComingFromBookingFlow(false);
	}, [
		isServiceTypeValid,
		selectedServiceType,
		handleOpenBookingConfirmationDrawer,
		setIsComingFromBookingFlow,
	]);

	return (
		<SimpleConfirmationDrawer
			handleConfirmAndContinue={handleConfirmAndContinue}
			isOpened={bookingConfirmationDrawerIsOpened}
			handleOpen={handleOpenBookingConfirmationDrawer}
			handleClose={handleCloseBookingConfirmationDrawer}
			serviceType={selectedServiceType}
		/>
	);
}

export {ConfirmationDrawer};
